import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { EnvelopeSimple } from "@phosphor-icons/react";
import api, { formatApiError } from "@/lib/api";

const COPY = {
  weekly: {
    title: "Weekly lead report",
    ask: "Stop getting the Monday email with your leads, sold rate and top states?",
    button: "Turn off weekly email",
    done: "Done. You won't get the Monday email any more. To turn it back on, sign in and use the Weekly email switch on Traffic Results.",
  },
  alerts: {
    title: "Busy-hour alerts",
    ask: "Stop getting busy-hour alert emails and notices?",
    button: "Turn off busy-hour alerts",
    done: "Done. Busy-hour alerts are off. To turn them back on, sign in and use the Busy-hour alerts switch on Traffic Results.",
  },
};

export default function UnsubscribeWeekly({ kind = "weekly" }) {
  const [params] = useSearchParams();
  const token = params.get("t") || "";
  const copy = COPY[kind];
  const [state, setState] = useState("ask");
  const [msg, setMsg] = useState("");
  const stop = async () => {
    setState("busy");
    try {
      await api.post("/public/media-buyer/weekly-unsubscribe", { token, kind });
      setState("done");
    } catch (e) {
      const status = e?.response?.status;
      setMsg(status >= 400 && status < 500
        ? "This link is no longer valid."
        : formatApiError(e?.response?.data?.detail) || "Something went wrong. Please try again.");
      setState("error");
    }
  };
  return (
    <div className="min-h-screen bg-zinc-100 flex items-center justify-center p-6" data-testid="unsubscribe-weekly-page">
      <div className="brut-card bg-white p-8 max-w-md w-full">
        <EnvelopeSimple size={28} weight="bold" />
        <h1 className="font-chivo font-black uppercase tracking-tight text-2xl mt-3" data-testid="unsubscribe-weekly-title">{copy.title}</h1>
        {state === "done" ? (
          <p className="text-sm text-zinc-700 mt-3" data-testid="unsubscribe-weekly-done">{copy.done}</p>
        ) : (
          <>
            <p className="text-sm text-zinc-700 mt-3">{copy.ask}</p>
            {state === "error" && <p className="text-sm text-red-700 mt-3" data-testid="unsubscribe-weekly-error">{msg}</p>}
            <button type="button" onClick={stop} disabled={!token || state === "busy"} data-testid="unsubscribe-weekly-confirm"
                    className="mt-6 w-full border-2 border-black bg-black text-white px-4 py-2.5 text-xs uppercase tracking-widest font-bold disabled:opacity-50 hover:bg-zinc-800 transition-colors">
              {state === "busy" ? "Turning off…" : copy.button}
            </button>
            {!token && <p className="text-xs text-zinc-500 mt-3" data-testid="unsubscribe-weekly-missing">This link is missing its code. Use the link from the email.</p>}
          </>
        )}
        <Link to="/login" className="block text-xs underline mt-6" data-testid="unsubscribe-weekly-signin">Sign in</Link>
      </div>
    </div>
  );
}
